module.exports = __webpack_public_path__ + "static/media/notifyLight.64ebe382.svg";